import React, { useEffect,useState, useRef } from 'react';
import { Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import API from '../Utils/Api';

const BusinessSidebar = ({ isVisible, setIsVisible }) => {
  const [count, setCount] = useState(0);
  const sidebarRef = useRef(null);

  const [logo, setLogo] = useState('');

  const handleCloseSidebar = () => {
    setIsVisible(false); // Update the state to hide the sidebar
  };

  useEffect(() => {

      API.post('get_settings')
      .then(response => {
          
          if (response.data.status === false) {

          } else {
              setLogo(response.data.data.app_business_logo);
          }
      }).catch(error => {
          
      });

      fetchNotificationCount();            
      const interval = setInterval(() => {
        fetchNotificationCount();
      }, 10000);

      return () => clearInterval(interval);
 }, []);

  useEffect(() => {
    if (!isVisible) return;

    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsVisible(false); // inline instead of handleCloseSidebar()
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, setIsVisible]);

const fetchNotificationCount = () => {
        var url = 'get_business_notification_count';
        let formData = new FormData();
        if(localStorage.getItem("business_id")){
            formData.append('business_id', localStorage.getItem("business_id"));
        }
        API.post(url, formData)
            .then(response => {
                
                if (response.data.status === false) {

                } else {
                    setCount(response.data.data.notification);
                }
            }).catch(error => {
                
            });
    }

  return (
    <>
      <Col md={12} lg={3} xl={3} xxl={2} className={`px-0 nei-sidebar-main ${isVisible ? 'd-block' : 'd-none'}`}>
        <div className='nei-sidebar' ref={sidebarRef}>
          <div className='nei-sidebar-top'>
            <div className='cross-icn'>
              <Link to="" onClick={handleCloseSidebar}>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid" alt="cross-icn" />
              </Link>
            </div>
            <Link to="/" >
            {logo && (
            <Image src={logo} className="img-fluid nei-side-logo" alt="logo-busi" />
            )}
            </Link>
            <Link to="/business/my-deal" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/profile.webp'} className="img-fluid" alt="profile" />
                <h5>My Business</h5>
              </div>
            </Link>
            <Link to="/business/orders" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/my-order.webp'} className="img-fluid" alt="my-order" />
                <h5>My Order</h5>
              </div>
            </Link>
            <Link to="/business/membership" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/membership.webp'} className="img-fluid" alt="membership" />
                <h5>Membership</h5>
              </div>
            </Link>
            {/*<Link to="/business/message" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/msgicn.webp'} className="img-fluid" alt="msgicn" />
                <h5>Messages</h5>
              </div>
            </Link>*/}

            <Link to="/business/notification" className='nei-link'>
              <div className="notification-wrapper">
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/notiicn.webp'} className="img-fluid" alt="notiicn" />
                {count > 0 && (
                  <span className="notification-badge">{count > 99 ? '99+' : count}</span>
                )}
                <h5>Notifications</h5>
              </div>
            </Link>

            <Link to="/business/invite-a-neighbor" className='nei-link d-none'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ian.webp'} className="img-fluid" alt="ian" />
                <h5>Invite a Neighbor</h5>
              </div>
            </Link>
            <Link to="/business/contact-us" className='nei-link d-none'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cnt.webp'} className="img-fluid" alt="cnt" />
                <h5>Contact Us</h5>
              </div>
            </Link>
            <Link to="/" className='lo-link d-none'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/logout.webp'} className="img-fluid" alt="logout" />
                <h5>Logout</h5>
              </div>
            </Link>

            <div className='bui-sidebar-bot'>
              <Link to="/business/terms" className='text-link d-none'>
                <div>
                  <h5>Terms and Conditions</h5>
                </div>
              </Link>
              <Link to="/business/privacy" className='text-link d-none'>
                <div>
                  <h5>Privacy Policy</h5>
                </div>
              </Link>
              <Link to="/neighbour/view-profile" className='bu-btn-link d-none'>
                <div>
                  <h5>Neighborhood</h5>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </Col>
    </>
  )
}

export default BusinessSidebar;                    